module.exports = __webpack_public_path__ + "media/images/level_introduction5_sp-7c18405e341d3ca74e12e43086fa699c.png";